import React from 'react';
import PropTypes from 'prop-types';
import { WindowFrame, Step3, Step4 } from './';
import { LockDeviceType } from '../../LockDeviceType';
import Step2 from '../svg/Step2';

const Slider = props =>
  <div className="slider-wrapper">
    {props.step === 1 &&
      <WindowFrame dataStep={props.step}>
        <LockDeviceType {...props} />
      </WindowFrame>}

    {props.step === 2 &&
      <WindowFrame dataStep={props.step}>
        <Step2 {...props} />
      </WindowFrame>}

    {props.step === 3 &&
      <WindowFrame dataStep={props.step} wbColor="#F7F7F7">
        <Step3 {...props} />
      </WindowFrame>}

    {props.step === 4 &&
      <WindowFrame dataStep={props.step} whColor="#3A424A" wbColor="#2F383D">
        <Step4 {...props} />
      </WindowFrame>}
  </div>;

Slider.propTypes = {
  step: PropTypes.number.isRequired
};

export default Slider;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/components/Slider.js